export default __webpack_public_path__ + "static/media/logo-light.1b45f709.png";